import { useState, useRef } from 'react';

const LinkedInCard = () => (
  <div className="linkedin-card">
    <img src="/linkedinlogo.png" alt="LinkedIn" className="linkedin-card-logo" />
    <div className="linkedin-card-header">
      <img src="/linkedinpfp.png" alt="Sidharth Sudhir" className="linkedin-card-avatar" />
    </div>
    <div className="linkedin-card-name">
      Sidharth Sudhir <span className="linkedin-pronouns">He/Him</span>
    </div>
    <div className="linkedin-card-headline">SWE @ BlackRock | UCLA Alum</div>
    <div className="linkedin-card-location">New York City Metropolitan Area</div>
    <a href="https://sidharth.fyi" className="linkedin-card-website" target="_blank" rel="noopener noreferrer">
      sidharth.fyi
    </a>
    <div className="linkedin-card-connections">500+ connections</div>
    <a
      href="https://linkedin.com/in/sidsudhir"
      target="_blank"
      rel="noopener noreferrer"
      className="linkedin-card-connect"
    >
      Connect
    </a>
  </div>
);

const GitHubCard = () => {
  // Generate ~24 weeks (168 days) of realistic contribution data
  const generateContributions = () => {
    const contributions = [];
    for (let i = 0; i < 168; i++) {
      // Weighted random for realistic distribution:
      // ~35% empty, ~30% level 1, ~20% level 2, ~10% level 3, ~5% level 4
      const rand = Math.random();
      let level;
      if (rand < 0.35) level = 0;
      else if (rand < 0.65) level = 1;
      else if (rand < 0.85) level = 2;
      else if (rand < 0.95) level = 3;
      else level = 4;
      contributions.push(level);
    }
    return contributions;
  };

  const contributions = generateContributions();
  const weeks = [];
  for (let i = 0; i < contributions.length; i += 7) {
    weeks.push(contributions.slice(i, i + 7));
  }

  return (
    <div className="github-card">
      <div className="github-card-header">
        <img src="/pfp.jpeg" alt="Sidharth Sudhir" className="github-card-avatar" />
        <div className="github-card-details">
          <div className="github-card-info">
            <span className="github-card-name">Sidharth Sudhir</span>
            <span className="github-card-username">sidharthsudhir</span>
          </div>
          <a
            href="https://github.com/sidharthsudhir"
            target="_blank"
            rel="noopener noreferrer"
            className="github-card-follow"
          >
            Follow
          </a>
        </div>
      </div>
      <div className="github-card-stats">
        <span><strong>9</strong> followers</span>
        <span><strong>4</strong> following</span>
      </div>
      <div className="github-contribution-grid">
        {weeks.map((week, weekIndex) => (
          <div key={weekIndex} className="github-contribution-week">
            {week.map((level, dayIndex) => (
              <div
                key={dayIndex}
                className={`github-contribution-day level-${level}`}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const GmailCard = () => (
  <div className="gmail-card">
    <img src="/gmail.png" alt="Gmail" className="gmail-card-logo" />
    <div className="gmail-card-header">
      <div className="gmail-card-row">
        <span className="gmail-label">From:</span>
        <span className="gmail-value">Sidharth Sudhir</span>
      </div>
      <div className="gmail-card-row">
        <span className="gmail-label">To:</span>
        <span className="gmail-value">You</span>
      </div>
      <div className="gmail-card-row">
        <span className="gmail-label">Subject:</span>
        <span className="gmail-value gmail-subject">Let's connect!</span>
      </div>
    </div>
    <div className="gmail-divider"></div>
    <div className="gmail-card-body">
      Hey! Thanks for visiting. Feel free to reach out anytime.
    </div>
    <a
      href="mailto:sidharthsudhir12@gmail.com"
      className="gmail-send-btn"
    >
      Send
    </a>
  </div>
);

const TwitterCard = () => (
  <div className="twitter-card">
    <div className="twitter-card-header">
      <img src="/pfp.jpeg" alt="sidharth" className="twitter-card-avatar" />
      <a
        href="https://twitter.com/sidsudh1r"
        target="_blank"
        rel="noopener noreferrer"
        className="twitter-card-follow"
      >
        Follow
      </a>
    </div>
    <div className="twitter-card-name">
      sidharth <img src="/twitterverified.png" alt="verified" className="twitter-verified" />
    </div>
    <div className="twitter-card-handle">@sidsudh1r</div>
    <p className="twitter-card-bio">
      swe | prev <span className="twitter-link">@blackrock</span> <span className="twitter-link">@ucla</span>
    </p>
    <div className="twitter-card-stats">
      <span><strong>229</strong> Following</span>
      <span><strong>459</strong> Followers</span>
    </div>
  </div>
);

const Footer = () => {
  const [showTwitterCard, setShowTwitterCard] = useState(false);
  const [showLinkedInCard, setShowLinkedInCard] = useState(false);
  const [showGitHubCard, setShowGitHubCard] = useState(false);
  const [showGmailCard, setShowGmailCard] = useState(false);
  const [isTwitterCardHovered, setIsTwitterCardHovered] = useState(false);
  const [isLinkedInCardHovered, setIsLinkedInCardHovered] = useState(false);
  const [isGitHubCardHovered, setIsGitHubCardHovered] = useState(false);
  const [isGmailCardHovered, setIsGmailCardHovered] = useState(false);
  const [twitterCardPos, setTwitterCardPos] = useState({ x: 0, y: 0 });
  const [linkedInCardPos, setLinkedInCardPos] = useState({ x: 0, y: 0 });
  const [gitHubCardPos, setGitHubCardPos] = useState({ x: 0, y: 0 });
  const [gmailCardPos, setGmailCardPos] = useState({ x: 0, y: 0 });
  const twitterTimeoutRef = useRef(null);
  const linkedInTimeoutRef = useRef(null);
  const gitHubTimeoutRef = useRef(null);
  const gmailTimeoutRef = useRef(null);

  const handleTwitterEnter = (e) => {
    if (twitterTimeoutRef.current) clearTimeout(twitterTimeoutRef.current);
    const rect = e.target.getBoundingClientRect();
    setTwitterCardPos({ x: rect.left, y: rect.bottom + 10 });
    setShowTwitterCard(true);
  };

  const handleTwitterLeave = () => {
    twitterTimeoutRef.current = setTimeout(() => {
      if (!isTwitterCardHovered) setShowTwitterCard(false);
    }, 100);
  };

  const handleTwitterCardEnter = () => {
    if (twitterTimeoutRef.current) clearTimeout(twitterTimeoutRef.current);
    setIsTwitterCardHovered(true);
  };

  const handleTwitterCardLeave = () => {
    setIsTwitterCardHovered(false);
    setShowTwitterCard(false);
  };

  const handleLinkedInEnter = (e) => {
    if (linkedInTimeoutRef.current) clearTimeout(linkedInTimeoutRef.current);
    const rect = e.target.getBoundingClientRect();
    setLinkedInCardPos({ x: rect.left, y: rect.bottom + 10 });
    setShowLinkedInCard(true);
  };

  const handleLinkedInLeave = () => {
    linkedInTimeoutRef.current = setTimeout(() => {
      if (!isLinkedInCardHovered) setShowLinkedInCard(false);
    }, 100);
  };

  const handleLinkedInCardEnter = () => {
    if (linkedInTimeoutRef.current) clearTimeout(linkedInTimeoutRef.current);
    setIsLinkedInCardHovered(true);
  };

  const handleLinkedInCardLeave = () => {
    setIsLinkedInCardHovered(false);
    setShowLinkedInCard(false);
  };

  const handleGitHubEnter = (e) => {
    if (gitHubTimeoutRef.current) clearTimeout(gitHubTimeoutRef.current);
    const rect = e.target.getBoundingClientRect();
    setGitHubCardPos({ x: rect.left, y: rect.bottom + 10 });
    setShowGitHubCard(true);
  };

  const handleGitHubLeave = () => {
    gitHubTimeoutRef.current = setTimeout(() => {
      if (!isGitHubCardHovered) setShowGitHubCard(false);
    }, 100);
  };

  const handleGitHubCardEnter = () => {
    if (gitHubTimeoutRef.current) clearTimeout(gitHubTimeoutRef.current);
    setIsGitHubCardHovered(true);
  };

  const handleGitHubCardLeave = () => {
    setIsGitHubCardHovered(false);
    setShowGitHubCard(false);
  };

  const handleGmailEnter = (e) => {
    if (gmailTimeoutRef.current) clearTimeout(gmailTimeoutRef.current);
    const rect = e.target.getBoundingClientRect();
    setGmailCardPos({ x: rect.left, y: rect.bottom + 10 });
    setShowGmailCard(true);
  };

  const handleGmailLeave = () => {
    gmailTimeoutRef.current = setTimeout(() => {
      if (!isGmailCardHovered) setShowGmailCard(false);
    }, 100);
  };

  const handleGmailCardEnter = () => {
    if (gmailTimeoutRef.current) clearTimeout(gmailTimeoutRef.current);
    setIsGmailCardHovered(true);
  };

  const handleGmailCardLeave = () => {
    setIsGmailCardHovered(false);
    setShowGmailCard(false);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <h3 className="section-title">links</h3>
        <div className="footer-links">
          <span className="linkedin-link-wrapper">
            <a
              href="https://linkedin.com/in/sidsudhir"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              onMouseEnter={handleLinkedInEnter}
              onMouseLeave={handleLinkedInLeave}
            >
              LinkedIn
            </a>
            {(showLinkedInCard || isLinkedInCardHovered) && (
              <div
                className="linkedin-card-container"
                style={{
                  position: 'fixed',
                  left: linkedInCardPos.x,
                  top: linkedInCardPos.y,
                }}
                onMouseEnter={handleLinkedInCardEnter}
                onMouseLeave={handleLinkedInCardLeave}
              >
                <LinkedInCard />
              </div>
            )}
          </span>
          <span className="footer-separator">:</span>
          <span className="twitter-link-wrapper">
            <a
              href="https://twitter.com/sidsudh1r"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              onMouseEnter={handleTwitterEnter}
              onMouseLeave={handleTwitterLeave}
            >
              Twitter
            </a>
            {(showTwitterCard || isTwitterCardHovered) && (
              <div
                className="twitter-card-container"
                style={{
                  position: 'fixed',
                  left: twitterCardPos.x,
                  top: twitterCardPos.y,
                }}
                onMouseEnter={handleTwitterCardEnter}
                onMouseLeave={handleTwitterCardLeave}
              >
                <TwitterCard />
              </div>
            )}
          </span>
          <span className="footer-separator">:</span>
          <span className="github-link-wrapper">
            <a
              href="https://github.com/sidharthsudhir"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              onMouseEnter={handleGitHubEnter}
              onMouseLeave={handleGitHubLeave}
            >
              GitHub
            </a>
            {(showGitHubCard || isGitHubCardHovered) && (
              <div
                className="github-card-container"
                style={{
                  position: 'fixed',
                  left: gitHubCardPos.x,
                  top: gitHubCardPos.y,
                }}
                onMouseEnter={handleGitHubCardEnter}
                onMouseLeave={handleGitHubCardLeave}
              >
                <GitHubCard />
              </div>
            )}
          </span>
          <span className="footer-separator">:</span>
          <span className="gmail-link-wrapper">
            <a
              href="mailto:sidharthsudhir12@gmail.com"
              className="footer-link"
              onMouseEnter={handleGmailEnter}
              onMouseLeave={handleGmailLeave}
            >
              Email
            </a>
            {(showGmailCard || isGmailCardHovered) && (
              <div
                className="gmail-card-container"
                style={{
                  position: 'fixed',
                  left: gmailCardPos.x,
                  top: gmailCardPos.y,
                }}
                onMouseEnter={handleGmailCardEnter}
                onMouseLeave={handleGmailCardLeave}
              >
                <GmailCard />
              </div>
            )}
          </span>
        </div>
      </div>
    </footer>
  );
};

const FooterMeta = () => (
  <div className="footer-meta">
    <p className="footer-date">Updated Dec 2025</p>
    <p className="copyright">© {new Date().getFullYear()} Sidharth Sudhir</p>
  </div>
);

export default Footer;
export { FooterMeta };
